import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateLessonTableAction,
  createLessonTableAction,
} from "../../../../../redux/actions/lessonTableActions";
import { SEARCH_VALUES_ACTION_TYPES } from "../../../../../redux/actions-type";
import LoadingBtn from "../../../../Loading/components/LoadingBtn/LoadingBtn";

const SubmitBtn = ({ formik, modalData, funcType }) => {
  const dispatch = useDispatch();

  const { status, type } = useSelector((state) => state.lessonTablePagination);
  const { startDate, endDate } = useSelector((state) => state.datepicker);
  const { lessonTableSearchValues } = useSelector(
    (state) => state.searchValues
  );
  const { selectedTeacher } = useSelector((state) => state.dropdownTeacher);
  const { selectedGroup, groupStatus } = useSelector(
    (state) => state.dropdownGroup
  );

  const { lessonTableModalLoading: modalLoading } = useSelector(
    (state) => state.lessonTableModal
  );
  const [isDisabled, setIsDisabled] = useState(() => {
    if (funcType === "update") {
      return false;
    } else {
      return true;
    }
  });

  const dataCreate = () => {
    dispatch({
      type: SEARCH_VALUES_ACTION_TYPES.LESSON_TABLE_SEARCH_VALUE,
      payload: "",
    });
    if (modalData?._id) {
      dispatch(
        updateLessonTableAction(
          modalData?._id,
          modalData,
          lessonTableSearchValues,
          selectedGroup?._id || "",
          selectedTeacher._id,
          startDate,
          endDate,
          status,
          groupStatus,
          type === "all" ? "" : type
        )
      );
    } else {
      dispatch(createLessonTableAction(modalData));
    }
  };

  useEffect(() => {
    setIsDisabled(() => {
      if (funcType === "update") {
        // console.log(Object.keys(formik.errors), "bir bir bir");
        if (Object.keys(formik.errors).length === 0) {
          return false;
        } else if (
          Object.keys(formik.errors).length === 1 &&
          formik.errors.password === "Bu xana tələb olunur."
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        if (formik.isValid) {
          return false;
        } else {
          return true;
        }
      }
    });
  }, [formik.errors]);

  return (
    <>
      <div className="create-update-modal-btn">
        <button disabled={isDisabled} onClick={dataCreate}>
          {modalLoading ? (
            <LoadingBtn />
          ) : funcType === "update" ? (
            "Yenilə"
          ) : (
            "Yarat"
          )}
        </button>
      </div>
    </>
  );
};

export default SubmitBtn;
